<span *ngIf="innerWidth >= breakpoint">
	 • 
</span>
<span *ngIf="innerWidth < breakpoint">
	<br />
</span>